import React, { useEffect, useState } from "react";
import { FaBan, FaCheckCircle } from "react-icons/fa";
import { useParams } from "react-router-dom";
import axios from "axios";

const Consentfile = () => {
    const { token1, token2, companyName } = useParams();
    const decodedCompanyName = decodeURIComponent(companyName || "");

    const [status, setStatus] = useState(null); 
    const [message, setMessage] = useState("");
    const [ipAddress, setIpAddress] = useState("");

    // Load stored consent if already given
    useEffect(() => {
        const savedConsent = localStorage.getItem(`consent_${token1}_${token2}`);
        if (savedConsent) {
            const { status, message } = JSON.parse(savedConsent);
            setStatus(status);
            setMessage(message);
        }
    }, [token1, token2]);

        useEffect(() => {
        const fetchIP = async () => {
            try {
                const res = await fetch("https://api.ipify.org?format=json");
                const data = await res.json();
                setIpAddress(data.ip);
            } catch (err) {
                console.error("Error fetching IP:", err);
            }
        };
        fetchIP();
    }, []);

    console.log(ipAddress,'ipaddress');
    

    const handleConsent = async (consent) => {
        try {
            const payload = {
                customer_id: token1,
                concern_id: token2,
                call_accepted: consent === "accept" ? "accepted" : "rejected",
                 ip_address: ipAddress || "Unavailable",
            };

            const response = await axios.post("/api/agents/call/consent-response/", payload);
            if (response.status === 200) {
                let newStatus, newMessage;

                if (consent === "accept") {
                    newStatus = "success";
                    newMessage = `Thank you! You have successfully provided consent to receive communication from ${decodedCompanyName}.`;
                } else {
                    newStatus = "rejected";
                    newMessage = `You have declined to receive communication from ${decodedCompanyName}.`;
                }

                setStatus(newStatus);
                setMessage(newMessage);

                // Save in localStorage
                localStorage.setItem(
                    `consent_${token1}_${token2}`,
                    JSON.stringify({ status: newStatus, message: newMessage })
                );
            }
        } catch (error) {
            console.log(error.response.data.message)
            if(error.response.data.message){
                setMessage(error.response.data.message)
            }
            console.error("Error recording consent:", error);
            setStatus("error");
            setMessage("An error occurred while recording your response. Please try again later.");
        }
    };

    return (
        <div className="row justify-content-center">
            <div className="col-xl-4">
                <div className="card mt-5 mx-1 shadow-sm border-0" style={{ borderRadius: "12px" }}>
                    <div className="card-body p-4">
                        <div className="text-center mb-3">
                            <img src="/assets/images/logo.png" height="90" alt="logo" />
                        </div>

                        {!status && (
                            <>
                                <h4 className="text-center fw-semibold mb-4">
                                    Consent to Receive Communication from {decodedCompanyName}
                                </h4>

                                <p className="text-center text-muted fs-6 mb-4">
                                    By confirming below, you consent to receive calls, SMS, WhatsApp messages,
                                    and/or emails from <strong>{decodedCompanyName}</strong> regarding our products,
                                    services, and updates.
                                </p>

                                <div className="d-flex flex-column gap-3 align-items-center mt-4">
                                    <button
                                        className="btn btn-success btn-md w-75 d-flex justify-content-center align-items-center"
                                        onClick={() => handleConsent("accept")}
                                    >
                                        <FaCheckCircle className="me-2" size={18} />
                                        I Consent
                                    </button>

                                    <button
                                        className="btn btn-danger btn-md w-75 d-flex justify-content-center align-items-center"
                                        onClick={() => handleConsent("reject")}
                                    >
                                        <FaBan className="me-2" size={18} />
                                        I Do Not Consent
                                    </button>
                                </div>
                            </>
                        )}

                        {status && (
                            <div className="text-center mt-4">
                                {status === "success" && (
                                    <FaCheckCircle className="text-success mb-3" size={48} />
                                )}
                                {status === "rejected" && (
                                    <FaBan className="text-danger mb-3" size={48} />
                                )}
                                {status === "error" && (
                                    <FaBan className="text-warning mb-3" size={48} />
                                )}

                                <h5 className="fw-semibold text-danger">{message}</h5>
                                <p className="text-white mt-3">You can now safely close this window.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Consentfile;
